import {Action} from '@ngrx/store';
import {Adjunto} from './adjuntos.state';

export enum AdjuntoActionTypes {
  LOAD_REQUEST = '[ADJUNTOS] Load Request',
  LOAD_FAILURE = '[ADJUNTOS] Load Failure',
  LOAD_SUCCESS = '[ADJUNTOS] Load Success',
  ADD_REQUEST = '[ADJUNTOS] Add Request',
  ADD_FAILURE = '[ADJUNTOS] Add Failure',
  ADD_SUCCESS = '[ADJUNTOS] Add Success',
  ADD_MANY_REQUEST = '[ADJUNTOS] Add Many Request',
  ADD_MANY_FAILURE = '[ADJUNTOS] Add Many Failure',
  ADD_MANY_SUCCESS = '[ADJUNTOS] Add Many Success',
  ADD_REQUEST_WITH_CALLBACK = '[ADJUNTOS] Add Request With Callback',
  ADD_MANY_REQUEST_WITH_CALLBACK = '[ADJUNTOS] Add Many Request With Callback',
  DELETE_REQUEST = '[ADJUNTOS] Delete Request',
  DELETE_FAILURE = '[ADJUNTOS] Delete Failure',
  DELETE_SUCCESS = '[ADJUNTOS] Delete Success',
}

// load
export class AdjuntosLoadRequestAction implements Action {
  readonly type = AdjuntoActionTypes.LOAD_REQUEST;
}

export class AdjuntosLoadFailureAction implements Action {
  readonly type = AdjuntoActionTypes.LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class AdjuntosLoadSuccessAction implements Action {
  readonly type = AdjuntoActionTypes.LOAD_SUCCESS;

  constructor(public payload: { items: Adjunto[] }) {
  }
}

// add
export class AdjuntosAddRequestAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_REQUEST;

  constructor(public payload: { item: Adjunto, dibujoId?: number }) {
  }
}

export class AdjuntosAddFailureAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class AdjuntosAddSuccessAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_SUCCESS;

  constructor(public payload: { item: Adjunto, dibujoId: number }) {
  }
}

// add many
export class AdjuntosAddManyRequestAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_MANY_REQUEST;

  constructor(public payload: { items: Adjunto[], dibujoId?: number }) {
  }
}

export class AdjuntosAddManyFailureAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_MANY_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class AdjuntosAddManySuccessAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_MANY_SUCCESS;

  constructor(public payload: { items: Adjunto[], dibujoId?: number }) {
  }
}

// add with callback
export class AdjuntosAddRequestWithCallbackAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_REQUEST_WITH_CALLBACK;

  constructor(public payload: { item: Adjunto, dibujoId?: number },
              public actionCallback: any,
              public dataCallback: any,
              public adjuntoKey: string = 'adjuntoId') {
  }
}

// add many with callback
export class AdjuntosAddManyRequestWithCallbackAction implements Action {
  readonly type = AdjuntoActionTypes.ADD_MANY_REQUEST_WITH_CALLBACK;

  constructor(public payload: { items: Adjunto[], dibujoId?: number },
              public actionCallback: any,
              public dataCallback: any,
              public adjuntoKeys: {key: string, tipo: string}[],
              public rubro: string) {
  }
}

// delete
export class AdjuntosDeleteRequestAction implements Action {
  readonly type = AdjuntoActionTypes.DELETE_REQUEST;

  constructor(public payload: { item: Adjunto }) {
  }
}

export class AdjuntosDeleteFailureAction implements Action {
  readonly type = AdjuntoActionTypes.DELETE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class AdjuntosDeleteSuccessAction implements Action {
  readonly type = AdjuntoActionTypes.DELETE_SUCCESS;

  constructor(public payload: { item: Adjunto }) {
  }
}

// actions
export type AdjuntosActions =
  | AdjuntosLoadRequestAction
  | AdjuntosLoadFailureAction
  | AdjuntosLoadSuccessAction
  | AdjuntosAddRequestAction
  | AdjuntosAddFailureAction
  | AdjuntosAddSuccessAction
  | AdjuntosAddManyRequestAction
  | AdjuntosAddManyFailureAction
  | AdjuntosAddManySuccessAction
  | AdjuntosAddRequestWithCallbackAction
  | AdjuntosAddManyRequestWithCallbackAction
  | AdjuntosDeleteRequestAction
  | AdjuntosDeleteFailureAction
  | AdjuntosDeleteSuccessAction;
